const m29_municipalities = {
  'Eemsdelta': {
    searchKeys: [],
    exactMatchKeys: ['eemsdelta']
  },
  'Groningen': {
    searchKeys: [],
    exactMatchKeys: ['groningen']
  },
  'Het Hogeland': {
    searchKeys: [],
    exactMatchKeys: ['hogeland']
    // additional properties can be added here
  },
  'Midden-Groningen': {
    searchKeys: [],
    exactMatchKeys: ['midden-groningen', 'midden-groningen', 'middengroningen', 'mg'],
  },
  'Oldambt': {
    searchKeys: [],
    exactMatchKeys: ['oldambt']
  },
  'Pekela': {
    searchKeys: [],
    exactMatchKeys: ['pekela']
  },
  'Stadskanaal': {
    searchKeys: [],
    exactMatchKeys: ['stadskanaal']
  },
  'Veendam': {
    searchKeys: [],
    exactMatchKeys: ['veendam']
  },
  'Westerkwartier': {
    searchKeys: [],
    exactMatchKeys: ['westerkwartier']
  },
  'Westerwolde': {
    searchKeys: [],
    exactMatchKeys: ['westerwolde']
  },
  'Noordenveld': {
    searchKeys: [],
    exactMatchKeys: ['noordenveld']
  },
  'Aa en Hunze': {
    searchKeys: [],
    exactMatchKeys: ['aa en hunze', 'aa-en-hunze', 'aaenhunze']
  },
  'Tynaarlo': {
    searchKeys: [],
    exactMatchKeys: ['tynaarlo', 'tynaarloo']
  }
};

const otherInterests = {
  'Bosman': {
    searchKeys: [],
    exactMatchKeys: ['bosman']
  }
};

// attempt to match against municipality array, if not found return original value
// if includeAppName is true, prefix the src with the current host
export function getLeadSource(srcValue = null, includeAppName = true, includeAppNameIfUnmatched = true, capitalize = true)
{
  // Use the current host, falling back to the default for localhost or an empty host
  let host = 'meedoen.bureauverduurzamen.nl';
  if (window.location.host && window.location.hostname !== 'localhost') {
    host = window.location.host;
  }

  if (!srcValue) return host;

  // combine both interest lists into one variable
  const allSources = { ...m29_municipalities, ...otherInterests };

  // iterate through all sources, check both searchKeys and exactMatchKeys. If match, only store key value
  let matchedSource = null;
  for (const [name, data] of Object.entries(allSources)) {
    // check exactMatchKeys first
    if (data.exactMatchKeys) {
      for (const key of data.exactMatchKeys) {
        if (srcValue.toLowerCase() === key.toLowerCase()) {
          matchedSource = [name];
          break;
        }
      }
    }
    if (matchedSource) break;

    // then check searchKeys
    for (const key of data.searchKeys) {
      if (srcValue.toLowerCase().includes(key.toLowerCase())) {
        matchedSource = [name];
        break;
      }
    }
    if (matchedSource) break;
  }

  if (matchedSource) {
    const [name] = matchedSource;
    return includeAppName ? `${host} - ${name}` : name;
  } else if (includeAppNameIfUnmatched) {
    if (capitalize) {
      srcValue = capitalizeLeadSource(srcValue);
    }
    return `${host} - ${srcValue}`;
  }
  return srcValue;
}

export function capitalizeLeadSource(inputString) {
  // capitalize the first letter of each word, and the first letter after a hyphen
  // eg: midden-groningen -> Midden-Groningen
  // eg: veendam-noord -> Veendam-Noord
  // eg: veendam noord -> Veendam Noord
  return inputString.replace(/(?:^|\s|-)\S/g, function(a) { return a.toUpperCase(); });
}
